import React from 'react';
import { Box, Typography } from 'vindi-ds-components';
import toBrl from '@utils/format_currency';
import token from 'vindi-ds-tokens';

function PricingFooter({ minimumPrice, price }) {
  return (
    <Box
      display='flex'
      justifyContent='space-between'
      mt={token.spacing.small.value}
      mb={token.spacing.small.value}
    >
      <Price title='Preço Minimo' value={minimumPrice} />
      <Price title='Custo Fixo' value={price} />
    </Box>
  );
}

const Price = ({ title, value }) => (
  <Box>
    <Typography variant='body2' component='p'>
      { title }
    </Typography>
    <Typography variant='body1' component='p'>
      { value ? toBrl(value) : '-' }
    </Typography>
  </Box>
);

export default PricingFooter;
